/**
 * @desc - スムーススクロール
 * @link - http://pasolavo.com/web/fixing-jquery-smooth-scroll.html
 */
$(function () {
  var headerHight = 100;
  $('a[href^=#]').click(function () {
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - headerHight;
    $('body,html').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
});